const TedShutDownIcon = () => (
  <div>
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="8" fill="#EFF8FF" />
      <path
        d="M23.3033 12.4698C24.3522 13.5373 25.0665 14.8973 25.3559 16.378C25.6453 17.8586 25.4968 19.3933 24.9291 20.7881C24.3614 22.1828 23.4001 23.3749 22.1668 24.2136C20.9334 25.0523 19.4834 25.5 18 25.5C16.5166 25.5 15.0666 25.0523 13.8332 24.2136C12.5999 23.3749 11.6386 22.1828 11.0709 20.7881C10.5033 19.3933 10.3547 17.8586 10.6441 16.378C10.9335 14.8973 11.6478 13.5373 12.6967 12.4698M18 10.5V14.4396"
        stroke="#2751CE"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  </div>
);
export default TedShutDownIcon;
